export const CoinexIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
    >
      <defs>
        <linearGradient
          id="linear0"
          x1="-631.47"
          x2="-633.88"
          y1="588.08"
          y2="588.08"
          gradientTransform="matrix(23.92097 0 0 -24.46015 15162.341 14415.714)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#22E6B8"></stop>
          <stop offset="1" stopColor="#00C1CE"></stop>
        </linearGradient>
      </defs>
      <path
        fill="url(#linear0)"
        d="M38.82 21.8c-4.617-4.476-11.996-4.476-16.617 0a11.524 11.524 0 00-3.418 8.216 11.518 11.518 0 003.465 8.195c4.605 4.535 12.035 4.555 16.668.05.082-.081.406-.429.977-1.054l-5.547-5.46c-.567.655-.868.995-.907 1.026a4.044 4.044 0 01-5.664 0 3.892 3.892 0 01-.05-5.535 4.038 4.038 0 015.617.043l14.82 14.582c-4.156 5.89-10.941 9.41-18.191 9.434-10.356.004-19.309-7.156-21.496-17.192-2.192-10.035 2.98-20.222 12.41-24.464 9.43-4.239 20.566-1.38 26.738 6.863-.648.754-2.32 2.629-5.012 5.625l5.492 5.355 9.047-10.066C51.094 3.977 35.977-2.988 21.707 1.086 7.437 5.164-1.629 19.036.453 33.613c2.082 14.578 14.672 25.41 29.52 25.403 7.492 0 13.687-2.313 19.75-7.43a31.58 31.58 0 008.12-11.023zm0 0"
      ></path>
    </svg>
  );
}